import React from "react"
import PageHead from "components/pageHead"
import Layout from "components/layout"
import HomeProjects from "components/_home/homeProjects"
import HomeStrategy from "components/_home/homeStrategy"
import HomeNews from "components/_home/homeNews"
import Hero from "components/_hero/hero"
import HeroMobile from "components/_hero/heroMobile"
import HomeTestimonial from "components/_home/homeTestimonial"
import HrzRuler from "components/hrzRuler"
import HomeClients from "components/_home/homeClients"
import HomePartner from "components/_home/homePartner"
import HomeCTA from "components/_home/homeCTA"
import HomeFacts from "components/_home/homeFacts"

const Index = () => {
  return (
    <Layout>
      <main className="content-wrapper">
        <Hero className="d-none d-lg-block" />
        <section className="wrapper bg-gray">
          <div className="container">
            <div className="card shadow-none my-n13 my-md-n15 my-lg-n17">
              <div className="card-body py-8 py-lg-10 px-lg-11 px-xl-13">
                <HeroMobile />
                <HomeProjects />
                <HrzRuler />
                <HomeStrategy />
                <HrzRuler />
                <HomeNews />
                <HrzRuler />
                <HomeTestimonial />
                <HomeClients />
                <HrzRuler />
                <HomePartner />
                <HrzRuler />
                <HomeFacts />
                <HomeCTA />
              </div>
            </div>
          </div>
        </section>
      </main>
    </Layout>
  )
}

export default Index

export function Head({ location }) {
  const { pathname } = location
  return (
    <PageHead
      seo={{
        title: "European Stand Construction | com2com",
        metaDesc:
          "com2com: stand constructor from Belgium, located in the heart of Europe. Ahead of time, ahead of stress delivery",
        canonical: pathname,
      }}
    />
  )
}
